@if (projectDetails !== undefined) {
  <div class="my-3">
    <app-project-details-header [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-features [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-gallery [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-videos [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-downloads [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-section-a [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-section-b [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-section-c [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-section-d [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-section-e [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-section-f [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-section-g [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-section-h [projectDetails]="projectDetails" />
  </div>
  <div class="my-3">
    <app-project-details-section-i [projectDetails]="projectDetails" />
  </div>
  <!--div class="mt-3">
  <div>
    <label class="sub-header">{{
      translationKey + "mandatoryDeclarations" | translate
    }}</label>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="text-box">
        <p>
          {{ projectDetails.description }}
        </p>
      </div>
    </div>
  </div>
</div-->
}
